module.exports = __webpack_public_path__ + "media/images/ui__infoBoxSmall-0a7aa14b053d0d23f38b3483eb299e1b.png";